var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject } from "~/core/decorator";
import { Service } from "~/core/service";
var TelCaseManageService = /** @class */ (function (_super) {
    __extends(TelCaseManageService, _super);
    function TelCaseManageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 电催待分配查询列表
     */
    TelCaseManageService.prototype.waitDistribution = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.waitDistribution,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 电催个人案件池查询列表
     */
    TelCaseManageService.prototype.personalCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.personalCasePool,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 电催团队案件池查询列表
     */
    TelCaseManageService.prototype.teamCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.teamCasePool,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 回收案件池查询列表
     */
    TelCaseManageService.prototype.recoverCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.recoverCasePool,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 结清案件池查询列表
     */
    TelCaseManageService.prototype.settleCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.settleCasePool,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 结清案件池查询列表
     */
    TelCaseManageService.prototype.pauseCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.pauseCasePool,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 归C案件池查询列表
     */
    TelCaseManageService.prototype.returnCCasePool = function (data, page, sort) {
        return this.netService.send({
            server: domainService.telCaseManageController.returnCCasePool,
            data: data,
            page: page,
            sort: sort
        });
    };
    /**
     * 电催案件待分配手动分案预览
     */
    TelCaseManageService.prototype.telCaseManualDistribution = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.telCaseManualDistribution,
            data: data
        });
    };
    /**
     * 电催案件待分配手动分案确定分案
     */
    TelCaseManageService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.confirmDistributeCase,
            data: data
        });
    };
    /**
     * 电催案件手动分案预览
     */
    TelCaseManageService.prototype.reviewDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.reviewDistributeCase,
            data: data
        });
    };
    /**
     * 案件回收
     */
    TelCaseManageService.prototype.returnCase = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.returnCase,
            data: data
        });
    };
    /**
     * 移入电催待分配
     */
    TelCaseManageService.prototype.moveToWaitDistribution = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.moveToWaitDistribution,
            data: data
        });
    };
    /**
     * 个人案件池查询列表逾期总金额
     */
    TelCaseManageService.prototype.personalCasePoolAmount = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.personalCasePoolAmount,
            data: data,
        });
    };
    /**
     * 团队案件池查询列表逾期总金额
     * @param data
     */
    TelCaseManageService.prototype.teamCasePoolAmount = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.teamCasePoolAmount,
            data: data
        });
    };
    /**
     * 待分配案件池分案查询所选案件中的部门剩余催收天数的最小值
     * @param data
     */
    TelCaseManageService.prototype.getRemainingPartCollectionDays = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.getRemainingPartCollectionDays,
            data: {
                caseIds: data
            }
        });
    };
    /**
     * 委托方回收
     */
    TelCaseManageService.prototype.dealManualPartReturnCase = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.dealManualPartReturnCase,
            data: data
        });
    };
    /**
     * 归C案件池-退回待分配案件池
     * @param data
     */
    TelCaseManageService.prototype.returnWaitDistribution = function (data) {
        return this.netService.send({
            server: domainService.telCaseManageController.returnWaitDistribution,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], TelCaseManageService.prototype, "netService", void 0);
    return TelCaseManageService;
}(Service));
export { TelCaseManageService };
